import { e as STRIPE_SECRET_KEY } from "./private.js";
import Stripe from "stripe";
const stripe = new Stripe(STRIPE_SECRET_KEY);
const findCustomerByEmail = async (email) => {
  const response = await stripe.customers.list({
    email,
    limit: 1
  });
  if (!response || response?.data?.length === 0)
    throw new Error("A customer with that email doesn't exist.");
  return response.data[0];
};
const getLatestPaymentIntent = async (customerId) => {
  const response = await stripe.paymentIntents.list({
    customer: customerId
  });
  if (!response || response?.data?.length === 0)
    throw new Error("A payment couldn't be found for this customer.");
  return response.data[0];
};
export {
  findCustomerByEmail as f,
  getLatestPaymentIntent as g,
  stripe as s
};
